import React, { FC } from 'react';
import { Typography } from 'antd';
import { useTranslate } from '@/translations';

export const NotRecorded: FC = () => {
  const { t } = useTranslate();
  const text = t('tsNotRecorded');
  return (
    <Typography.Text type="secondary" title={text} aria-label={text}>
      —
    </Typography.Text>
  );
};
